import { saveState, getSavedState } from '@utils/local-storage'

/* state -------------------------------------------------------------------- */
export const state = {
  eventId: null,
  eventData: getSavedState('app.eventData') || null,
  verifMethod: {
    phone: '',
    access_code: '',
  },
  guestComment: {
    comment: '',
  },
  multimedia: {
    description: '',
    link_url: '',
  },
  verifResponseStatus: getSavedState('app.verifResponseStatus') || null,
  verifResponseContent: getSavedState('app.verifResponseContent') || null,
  tableDetail: null,
}

/* getters ------------------------------------------------------------------ */
export const getters = {
  eventId() {
    return state.eventId
  },
  eventData() {
    return state.eventData
  },
  verifMethod() {
    return state.verifMethod
  },
  guestComment() {
    return state.guestComment
  },
  multimedia() {
    return state.multimedia
  },
  verifResponseStatus() {
    return state.verifResponseStatus
  },
  verifResponseContent() {
    return state.verifResponseContent
  },
  tableDetail() {
    return state.tableDetail
  },
}

/* mutations ---------------------------------------------------------------- */
export const mutations = {
  SET_EVENT_ID(state, value) {
    state.eventId = value
  },
  SET_EVENT_DATA(state, value) {
    state.eventData = value
    saveState('app.eventData', value)
  },
  SET_VERIF_METHOD(state, value) {
    state.verifMethod = value
  },
  SET_GUEST_COMMENT(state, value) {
    state.guestComment = value
  },
  SET_MULTIMEDIA(state, value) {
    state.multimedia = value
  },
  SET_VERIF_RESPONSE_STATUS(state, value) {
    state.verifResponseStatus = value
    saveState('app.verifResponseStatus', value)
  },
  SET_VERIF_RESPONSE_CONTENT(state, value) {
    state.verifResponseContent = value
    saveState('app.verifResponseContent', value)
  },
  SET_TABLE_DETAIL(state, value) {
    state.tableDetail = value
  },
}

/* actions ------------------------------------------------------------------ */
export const actions = {
  init({ state, dispatch }) {
    dispatch('resetVerifData')
  },
  resetVerifData({ commit, dispatch }) {
    commit('SET_VERIF_METHOD', {
      phone: '',
      access_code: '',
    })
    commit('SET_VERIF_RESPONSE_STATUS', null)
    commit('SET_VERIF_RESPONSE_CONTENT', null)
  },
  setEventId({ commit, dispatch }, val) {
    commit('SET_EVENT_ID', val)
  },
  setEventData({ commit, dispatch }, val) {
    commit('SET_EVENT_DATA', val)
  },
  setVerifMethod({ commit, dispatch }, val) {
    commit('SET_VERIF_METHOD', val)
  },
  setGuestComment({ commit, dispatch }, val) {
    commit('SET_GUEST_COMMENT', val)
  },
  setMultimedia({ commit, dispatch }, val) {
    commit('SET_MULTIMEDIA', val)
  },
  setVerifResponseStatus({ commit, dispatch }, val) {
    commit('SET_VERIF_RESPONSE_STATUS', val)
  },
  setVerifResponseContent({ commit, dispatch }, val) {
    commit('SET_VERIF_RESPONSE_CONTENT', val)
  },
  setTableDetail({ commit, dispatch }, val) {
    commit('SET_TABLE_DETAIL', val)
  },
}
